import Immutable from 'immutable';
import * as ActionTypes from 'constants/ActionTypes';

let initialState = Immutable.fromJS({});

export default function sparklines(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SPARKLINE_REQUEST_DATA:
      return state.setIn([action.itemSector, 'isFetching'], true);

    case ActionTypes.SPARKLINE_RECEIVE_DATA:
      return state.set(
        action.itemSector,
        Immutable.fromJS({
          isFetching: false,
          data: action.data,
        }),
      );

    case ActionTypes.SPARKLINE_CREATE:
      return state.set(
        action.itemSector,
        Immutable.fromJS({
          isFetching: false,
          data: [],
        }),
      );

    default:
      return state;
  }
}
